import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsMunicipalityMixin extends Vue {
  get isMunicipality() {
    return this.$store.getters.hasApiModuleМunicipality;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isMunicipalityCheck.ts